module.exports = __webpack_public_path__ + "logo.393bb3566b5737fe0b62.png";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/taxpadweb/src/assets/img/logo.png
// module id = ../../../../../src/assets/img/logo.png
// module chunks = 3